import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  levelsLength: 0,
  levels: [],
  level: {},
  levelError: "",
  formError: "",
};

export default function LevelReducer(state = initialData,action) {
  switch (action.type) {
    case actions.LOADING_LEVEL:
      return { ...state, loading: action.payload };
    case actions.LOADING_LEVEL_BY_ID:
      return { ...state, loadingById: action.payload };
    case actions.SAVE_LOADING_LEVEL:
      return { ...state, saveLoading: action.payload };
    case actions.GET_LEVEL:
      return {
        ...state,
        levels: action.payload.levels,
        levelsLength: action.payload.levelsLength,
      };
    case actions.GET_LEVEL_BY_ID:
      return {
        ...state, level: action.payload
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.LEVEL_FAIL:
      return { ...state, levelError: action.payload };
    default:
      return state;
  }
}
